var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7471 9.51515L1.48488 18.7863C1.31483 18.9319 1.0961 19.008 0.872386 18.9993C0.648674 18.9907 0.436462 18.898 0.278155 18.7396C0.119849 18.5813 0.0271096 18.3691 0.0184686 18.1454C0.00982756 17.9217 0.0859215 17.703 0.231545 17.5329L8.23155 9.53293L0.21375 1.63069C0.0681264 1.46065 -0.00796749 1.24191 0.000673552 1.0182C0.0093146 0.794489 0.102054 0.582275 0.26036 0.423969C0.418667 0.265663 0.630879 0.172922 0.854591 0.16428C1.0783 0.15564 1.29704 0.231735 1.46708 0.37736L10.7471 9.51515Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLight);
export default __webpack_public_path__ + "static/media/arrow-right-light.ee77e708e2ac125d38aa4e842b9eb07c.svg";
export { ForwardRef as ReactComponent };